import { render, staticRenderFns } from "./NormalArtistTemplate.vue?vue&type=template&id=b079d786&scoped=true&"
import script from "./NormalArtistTemplate.vue?vue&type=script&lang=js&"
export * from "./NormalArtistTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NormalArtistTemplate.vue?vue&type=style&index=0&id=b079d786&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b079d786",
  null
  
)

export default component.exports